// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import instance_ from './api/index';

Vue.prototype.instance = instance_;  //axios实例

import'lib-flexible/flexible.js';
// 引入echarts
import echarts from 'echarts';

/*引入使用图片预览插件*/
import ImageViewer from 'vue2-viewer';
Vue.use(ImageViewer);

/*引入资源请求插件*/
import VueResource from 'vue-resource'
/*使用VueResource插件*/
Vue.use(VueResource)

/*引入导出js*/
import htmlToPdf from './utils/htmlToPdf';
Vue.use(htmlToPdf);

// 引入axios
import axios from 'axios';
Vue.prototype.$axios = axios;
//Vue.prototype.HOST = '/api';
//axios.defaults.baseURL = '/api';
//axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
//axios.defaults.crossDomain = true;
//axios.defaults.withCredentials = true;  //设置cross跨域 并设置访问权限 允许跨域携带cookie信息
//axios.defaults.headers.common['Authorization'] = ''; // 设置请求头为 Authorization
// 引入qs
import qs from 'qs';
Vue.prototype.$qs = qs;

//全局导出excel
import outToExcel from './excel/outToExcel';
Vue.prototype.outToExcels = outToExcel;


//引入jsonp
import  {VueJsonp} from 'vue-jsonp'
Vue.use(VueJsonp)

//引入videoplayer
import VideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';
import videojs from 'video.js';
window.videojs = videojs;
require('videojs-contrib-hls/dist/videojs-contrib-hls.js');
Vue.use(VideoPlayer);


//发送请求的拦截器
axios.interceptors.request.use((config) => {
    if(config.method  === 'get'){
        config.data = qs.stringify(config.data);
  } 
  return config;
}, error => {
  return Promise.reject(error);
});
//响应数据的拦截器
axios.interceptors.response.use(response => {
    return response
}, error => {
    return Promise.resolve(error.response)
});

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js